<template>
  <div :class="b(modifiers)">
    <div
      key="primary"
      :class="b('primary')"
    >
      <slot name="primary"></slot>
    </div>
    <div
      key="secondary"
      :class="b('secondary')"
    >
      <slot name="secondary"></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import { PropType } from 'vue';

  const GRID_FALLBACK = '12';

  export const VERTICAL_ALIGNMENTS: string[] = ['top', 'center', 'bottom'];

  export type ViewportSetting = {
    xs?: 'string';
    sm?: 'string';
    md?: 'string';
  };

  export const ALLOWED_RATIOS_DESKTOP: string[] = ['6-6', '7-5', '8-4', '9-3', GRID_FALLBACK];
  export const ALLOWED_RATIOS_TABLET: string[] = ['6-6', GRID_FALLBACK];
  export const ALLOWED_RATIOS_PHONE: string[] = [GRID_FALLBACK];

  /**
   * Renders a CMS two column layout.
   */
  export default {
    name: 'c-cms-two-columns',

    // components: { },
    // mixins: [],

    props: {
      /**
       * Sets the ratio between the two columns for each breakpoint.
       */
      ratioOn: {
        type: Object as PropType<ViewportSetting>,
        default: () => ({}),
      },

      /**
       * Set reverse ordering of the slots per breakpoint.
       *
       * Example: { md: true } to reverse the ordering on 'md' viewports.
       */
      reverseOn: {
        type: Object as PropType<ViewportSetting>,
        default: () => ({}),
      },

      /**
       * Sets the vertical alignment of the content slots.
       */
      verticalAlignment: {
        type: String,
        default: 'top',
        validator(value: string) {
          return VERTICAL_ALIGNMENTS.includes(value);
        },
      },
    },
    // data() {
    //   return {};
    // },

    computed: {
      /**
       * Returns modifiers for the root element.
       *
       * @returns {Object}
       */
      modifiers(): Record<string, string | boolean> {
        const { ratioOn, verticalAlignment, reverseOn } = this;

        return {
          columnXs: ratioOn?.xs || GRID_FALLBACK,
          columnSm: ratioOn?.sm || GRID_FALLBACK,
          columnMd: ratioOn?.md || GRID_FALLBACK,
          reverseXs: reverseOn?.xs || false,
          reverseSm: reverseOn?.sm || false,
          reverseMd: reverseOn?.md || false,
          verticalAlignment,
        };
      },
    },
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>
